import { useContext, useEffect, useState } from "react";
import RelifeContactNew from "./homeLayout/RelifeContactNew";
import "./style/FAQ.css";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "./auth/AuthProvider";

const FAQ_ITEMS = [
  {
    q: "What is Introspecta?",
    a: "Introspecta is a guided self-reflection app. You answer short questions, choose from clear options, and receive calm reflections to help you understand what you feel and what you need next.",
  },
  {
    q: "Is Introspecta therapy?",
    a: "No. Introspecta is not therapy and doesn’t replace professional mental health care. It’s a private space for structured self-check-ins and clarity.",
  },
  {
    q: "Who is Introspecta for?",
    a: "For people who feel stuck, overwhelmed, emotionally tired, or simply want to understand themselves better—without pressure to journal or “have the right words.”",
  },
  {
    q: "How does it work?",
    a: "Each theme is divided into short phases. Every phase includes a small set of questions with clear options. Your choices guide the reflection you receive.",
  },
  {
    q: "How long does it take?",
    a: "Each phase take 10 minutes. You can pause anytime and continue later.",
  },
  {
    q: "Do I need to write or journal?",
    a: "No. You can use Introspecta without writing. If you want, you can add personal notes, but it’s optional.",
  },
  {
    q: "Can I use it if I don’t know how I feel?",
    a: "Yes. The questions are designed to help you find words and direction even when you feel “blank” or confused.",
  },
  {
    q: "Is my data private?",
    a: "We aim to collect the minimum needed to run the app. We don’t sell personal data. Details are in our Privacy Policy.",
  },
  {
    q: "Can I delete my account/data?",
    a: "Yes. You can request deletion via our support email. We’ll confirm once it’s completed.",
  },
  {
    q: "What if I’m in crisis or feel unsafe?",
    a: "Introspecta is not crisis support. If you feel in danger, contact local emergency services or a qualified professional right away.",
  },
  {
    q: "How do payments work?",
    a: "You get access according to the product you purchase (e.g., a theme). If something doesn’t work as expected, contact support.",
  },
  {
    q: "Do you offer refunds?",
    a: "Refunds depend on the type of purchase and how access was delivered. Please see our Refund Policy for details.",
  },
  {
    q: "I have a technical problem—what should I do?",
    a: "Email support with a screenshot, your device type, and what you tried. We’ll help as fast as possible.",
  },
  {
    q: "Can I use Introspecta on multiple devices?",
    a: "Yes, if you sign in with the same account. Your access should carry over.",
  },
];

export default function FAQ() {
  const [show, setShow] = useState(false);
  const [openQuestions, setOpenQuestions] = useState([]);

  const { user, googleUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const location = useLocation();
  useEffect(() => {
    // localStorage.setItem("postLoginRedirectTheme", prevLocation);

    if (!user && !googleUser) {
      // localStorage.setItem("postLoginRedirectTheme", prevLocation);
      localStorage.setItem("postLoginRedirect", location.pathname);
      // return;
    }
  }, [user, googleUser, navigate]);

  function handleAnswer(question) {
    setOpenQuestions(
      (prev) =>
        prev.includes(question)
          ? prev.filter((q) => q !== question) // close it
          : [...prev, question], // open it
    );
  }
  return (
    <>
      <section className="faq-page">
        <div className="faq-card">
          <h1 className="faq-title">Frequently Asked Questions</h1>

          <div className="faq-list">
            {FAQ_ITEMS.map((item) => (
              <div className="faq-item" key={item.q}>
                {!openQuestions.includes(item.q) ? (
                  <>
                    <div onClick={() => handleAnswer(item.q)}>
                      <h2 className="faq-question">{item.q}</h2>

                      <button
                        className={`arrowHead ${openQuestions.includes(item.q) ? "rotate" : ""}`}
                        style={{
                          color: "black",
                        }}
                      >
                        ˅
                      </button>

                      {/* <button className="arrowHead">˄</button> */}
                    </div>
                  </>
                ) : (
                  <>
                    <div onClick={() => handleAnswer(item.q)}>
                      <h2 className="faq-question">{item.q}</h2>

                      <button
                        className="arrowHead"
                        style={{
                          color: "black",
                        }}
                      >
                        ˄
                      </button>

                      {/* <button className="arrowHead">˄</button> */}
                    </div>
                    <div
                      className={`faq-answer-wrapper ${openQuestions.includes(item.q) ? "open" : ""}`}
                    >
                      <p className="faq-answer">{item.a}</p>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <RelifeContactNew />
    </>
  );
}
